// react
import React from "react"
import { connect } from "react-redux"
// app
import Licenses from "components/person/Licenses"
import Medicals from "components/person/Medicals"
import Visas from "components/person/Visas"

import { getLicenses, postLicense, putLicense, deleteLicense } from "actions/profile/licenses/actions.js"
import { getMedicals, postMedical, putMedical, deleteMedical } from "actions/profile/medicals/actions.js"
import { getVisas, postVisa, putVisa, deleteVisa } from "actions/profile/visas/actions.js"


class Step2 extends React.Component {
    constructor(props) {
        super()

        const personid = props.personid

        this.onLicenseAdd = license => {
            license.personid = personid
            this.props.postLicense(license)
        }
        this.onLicenseEdit = license => this.props.putLicense(license)
        this.onLicenseRemove = id => this.props.deleteLicense(id)

        this.onMedicalAdd = medical => {
            medical.personid = personid
            this.props.postMedical(medical)
        }
        this.onMedicalEdit = medical => this.props.putMedical(medical)
        this.onMedicalRemove = id => this.props.deleteMedical(id)

        this.onVisaAdd = visa => {
            visa.personid = personid
            this.props.postVisa(visa)
        }
        this.onVisaEdit = visa => this.props.putVisa(visa)
        this.onVisaRemove = id => this.props.deleteVisa(id)
    }

    componentDidMount() {
        const personid = this.props.personid
        
        this.props.getLicenses(personid)
        this.props.getMedicals(personid)
        this.props.getVisas(personid)
    }

    render() {
        const { type } = this.props

        return (
            <div>
                { type === "Pilot" || type === "Engineer" ?
                    <Licenses
                        data={ this.props.licenses }
                        onAdd={ this.onLicenseAdd }
                        onEdit={ this.onLicenseEdit }
                        onRemove={ this.onLicenseRemove }
                    />
                    : null
                }
                { type === "Pilot" || type === "Flight Attendant" ?
                    <Medicals
                        data={ this.props.medicals }
                        onAdd={ this.onMedicalAdd }
                        onEdit={ this.onMedicalEdit }
                        onRemove={ this.onMedicalRemove }
                    />
                    : null
                }
                <Visas
                    data={ this.props.visas }
                    onAdd={ this.onVisaAdd }
                    onEdit={ this.onVisaEdit }
                    onRemove={ this.onVisaRemove }
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        licenses: state.profile.licenses.get("data"),
        medicals: state.profile.medicals.get("data"),
        type: state.profile.person.get("data").get("type", "Pilot"),
        visas: state.profile.visas.get("data")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getLicenses: personid => dispatch(getLicenses(personid)),
        postLicense: license => dispatch(postLicense(license)),
        putLicense: license => dispatch(putLicense(license)),
        deleteLicense: id => dispatch(deleteLicense(id)),

        getMedicals: personid => dispatch(getMedicals(personid)),
        postMedical: medical => dispatch(postMedical(medical)),
        putMedical: medical => dispatch(putMedical(medical)),
        deleteMedical: id => dispatch(deleteMedical(id)),

        getVisas: personid => dispatch(getVisas(personid)),
        postVisa: visa => dispatch(postVisa(visa)),
        putVisa: visa => dispatch(putVisa(visa)),
        deleteVisa: id => dispatch(deleteVisa(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Step2)


/** WEBPACK FOOTER **
 ** ./src/containers/Profile/Step2.js
 **/